import cn from 'classnames';

import OPE from 'js/on-page-editing';

import Image from 'components/image/Image';

import { IPersonBlock } from 'source/NFR.types';

const PersonBlock: React.FC<IPersonBlock> = ({ company, image, jobTitle, name, onPageEditing, text }) => (
  <div className={cn('person-block', { 'person-block--has-image': image })}>
    {image && (
      <div className="person-block--image">
        <Image {...image} responsive={false} />
      </div>
    )}

    {name && <h3 {...OPE(onPageEditing?.name)}>{name}</h3>}
    <p className="person-block--job-title">
      <span {...OPE(onPageEditing?.jobTitle)}>{jobTitle}</span>
      <span {...OPE(onPageEditing?.company)}>{company}</span>
    </p>
    {text && (
      <p className="person-block--text" {...OPE(onPageEditing?.text)}>
        {text}
      </p>
    )}
  </div>
);

PersonBlock.displayName = 'PersonBlock';

export default PersonBlock;
